import * as z from 'zod';

export const ZEmailEntry = z.object({
    name: z.string(),
    email: z.email('Not a valid email'),
});

export type EmailEntry = z.infer<typeof ZEmailEntry>;

export const ZPaymentEmails = z.object({
    clients: z.array(ZEmailEntry),
    payer: ZEmailEntry.optional().nullable(),
    firm: ZEmailEntry.optional().nullable(),
});

export type PaymentEmails = z.infer<typeof ZPaymentEmails>;

export const ZEmailAttachment = z.object({
    filename: z.string(), // Name of the file attachment
    contentType: z.string().optional().nullable(), // e.g. text/plain or application/pdf
    encoding: z.enum(["ascii", "utf8", "utf16le", "ucs2", "base64", "binary", "hex"]).default("utf8"), // content encoding, e.g. base64
    disposition: z.enum(['attachment', 'inline']).default('attachment'), // attachment or inline
    content: z.string(), // Note: Buffers must be base64 encoded first
});

export type EmailAttachment = z.infer<typeof ZEmailAttachment>;

export const ZEmailOptions = z.object({
    from: z.email('Not a valid email'),
    to: z.array(z.email('Not a valid email')),
    cc: z.array(z.email('Not a valid email')).optional().nullable(),
    bcc: z.array(z.email('Not a valid email')).optional().nullable(),
    subject: z.string(),
    text: z.string(),
    html: z.string(),
    replyTo: z.string().optional().nullable(),
    attachments: z.array(ZEmailAttachment).optional().nullable(),
});

export type EmailOptions = z.infer<typeof ZEmailOptions>;

export const ZSendEmailResponse = z.object({
    // Was the message processed by SES?
    wasEmailProcessed: z.enum(["Yes", "No", "Maybe"]),

    // If the message was successfully processed, this is the message_id
    messageId: z.string().optional().nullable(),

    // If the message was not successfully processed, this is the error message
    errorMessage: z.string().optional().nullable(),
});

export type SendEmailResponse = z.infer<typeof ZSendEmailResponse>;
